
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateContactPersonDtoFormGroup() {
return new FormGroup({
    contactId: new FormControl<number | undefined>(undefined, [Validators.required]),
    firstName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    role: new FormControl<string | undefined>('STANDARD', [Validators.required]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
})
;
}
      